import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { AlertStatus } from "@sumprio/ui";
import { formatAlertMessage } from "utils/formatAlertMessage";

const DEFAULT_ALERT_FALLBACK = "Something went wrong. Please try again.";

export type GlobalAlertStatus = AlertStatus;

export interface GlobalAlertState {
  message: string | null;
  status: GlobalAlertStatus;
  dismissible: boolean;
  instanceId: number;
}

const initialState: GlobalAlertState = {
  message: null,
  status: "danger",
  dismissible: false,
  instanceId: 0,
};

const globalAlertSlice = createSlice({
  name: "globalAlert",
  initialState,
  reducers: {
    setGlobalAlert: (
      state,
      action: PayloadAction<{
        message: string | unknown;
        status?: GlobalAlertStatus;
        dismissible?: boolean;
      }>
    ) => {
      state.message = formatAlertMessage(action.payload.message, DEFAULT_ALERT_FALLBACK);
      state.status = action.payload.status ?? "danger";
      state.dismissible = action.payload.dismissible ?? false;
      state.instanceId += 1;
    },
    clearGlobalAlert: (state) => {
      state.message = null;
    },
  },
});

export const { setGlobalAlert, clearGlobalAlert } = globalAlertSlice.actions;

export const selectGlobalAlert = (state: {
  globalAlert?: GlobalAlertState | null;
}): GlobalAlertState =>
  state.globalAlert ?? {
    message: null,
    status: "danger",
    dismissible: false,
    instanceId: 0,
  };

export default globalAlertSlice.reducer;
